
/**
 * @export
 * @enum {string}
 */
export enum DraftSortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}